import React from 'react';
import './ThankYouModal.css';

const ThankYouModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="thank-you-modal-overlay" onClick={onClose}>
      <div className="thank-you-modal" onClick={e => e.stopPropagation()}>
        <button className="thank-you-modal-close" onClick={onClose}>
          ×
        </button>

        <div className="thank-you-modal-content">
          <h2 className="thank-you-title">THANK YOU</h2>
          <p className="thank-you-message">
            We'll be in touch very soon. We hope you're as excited as we are!
          </p>
        </div>
      </div>
    </div>
  );
};

export default ThankYouModal;
